/* eslint-disable quotes */
import each from 'lodash-es/each';
import escape from 'lodash-es/escape';
import find from 'lodash-es/find';

const sendAdMindImpressions = (recommedations) => {
  const admind_products = [];
  const country = window.theme.country_iso;
  const quadpay_country = country === `US`;

  let carousel_type = false;

  switch (recommedations.scheme) {
    case 'home1_rr':
      carousel_type = 'Recommended For You - Home';
      break;
    case 'category1_rr':
      carousel_type = 'Now Trending - Collection';
      break;
    case 'product1_rr':
    case 'product1_test_rr':
      carousel_type = 'You May Also Like - Product';
      break;
    case 'product2_rr':
    case 'product2_test_rr':
      carousel_type = 'Recommended For You - Product';
      break;
    case 'nosearch1_rr':
      carousel_type = 'Top Products - Search bar';
      break;
    case 'error1_rr':
    case 'error2_rr':
      carousel_type = 'May We Also Suggest - 404';
      break;
    case 'purchase1_rr':
      carousel_type = 'Now Trending - Purchase';
      break;
    case 'cart1_rr':
    case 'emptycart1_rr':
      carousel_type = 'Add the Final Touches - Cart';
      break;
  }
  each(recommedations.items, (product, index) => {
    const variants_with_availability = product.Child_Attributes.map((variant) => {
      const available = Number(variant.inventory) > 0;
      return {
        ...variant,
        available,
      };
    });
    const first_available = find(variants_with_availability, (variant) => {
      return variant.available;
    });

    const active_barcode = first_available ? first_available.barcode : product.Child_Attributes[0].barcode;
    const active_price = first_available ? first_available.price : product.Child_Attributes[0].price;
    const active_compare_at_price = first_available
      ? first_available.compare_at_price
      : product.Child_Attributes[0].compare_at_price;

    const admind_product = {
      id: Number(product.product_id),
      style: escape(active_barcode),
      // category: ,
      subcategory: escape(product.product_type),
      name: escape(product.Title.replace(/((CLEARANCE)|(PLACEHOLDER))( - )/, '')),
      price: active_price,
      originalPrice: active_compare_at_price,
      newArrival: product.tags.includes(`New Arrivals`),
      isMarkedDown: Number(active_price) < Number(active_compare_at_price),
      showsQuadpay: quadpay_country && Number(active_price) > 14,
      list: carousel_type,
      position: index + 1,
      // default to false assuming no first available meaning no inventory thus...cant be almost gone
      almostGone: first_available ? Number(first_available.inventory) < 10 : false,
      // No reviews for these products
      hasReviews: false,
      reviewCount: 0,
      reviewAverage: 0,
    };

    admind_products.push(admind_product);
  });

  if (carousel_type && admind_products.length > 0) {
    const dataLayer = window.dataLayer || [];

    dataLayer.push({
      event: `impressions`,
      ecommerce: {
        impressions: {
          products: admind_products,
        },
      },
    });
  }
};

let certonaLoadedCount = 0;
// TODO: do we need jquery for this for attaching events?
// $(document).on('certonaRecommendationsDidLoad', (e, params) => {
document.addEventListener('certonaRecommendationsDidLoad', (params) => {
  certonaLoadedCount++;
  if (certonaLoadedCount > 1) {
    return;
  }
  each(params.detail.resonance.schemes, (product_carousel) => {
    sendAdMindImpressions(product_carousel);
  });
});
